<template>
  <div v-if="showHeaderMenuAndFooter">
    <div class="wrapper">
      <the-banner />
      <impersonation-bar />
      <impersonated-notice />
      <impersonation-confirm-modal
        :open="confirmingLogout"
        title="Sair e encerrar personificação?"
        cancel-label="Continuar personificando"
        confirm-label="Sair e encerrar"
        loading-label="Saindo..."
        :loading="loggingOut"
        @cancel="cancelLogout"
        @confirm="runLogout">
        Você ainda está personificando <b>{{ impersonatedClientName }}</b>. Ao sair, a personificação será encerrada (o token é invalidado e a sessão fica registrada para auditoria) e em seguida você sai da sua conta de suporte.
      </impersonation-confirm-modal>
      <menu-header/>
      <div class="page-wrap">
        <menu-sidebar
          @open-tutorial-google-datastudio="openTutorialGoogleDataStudio"
          @request-logout="onRequestLogout" />
        <div class="main-content">
          <div class="container-fluid">
            <slot/>
          </div>
        </div>
        <footer class="footer">
          <div class="d-flex justify-content-between">
            <span class="text-center">Copyright © {{ currentYear }} API4COM. Todos direitos reservados.</span>
            <banner-footer />
            <span class="text-center">
              Developed <i class="ik ik-heart-on text-danger" /> by
              <a
                href="https://www.api4com.com"
                class="text-dark"
                target="_blank">Api4Com</a>
              Team
            </span>
          </div>
        </footer>
      </div>
    </div>
    <tutorial-video-modal
      ref="tutorialGoogleDataStudio"
      title="Tutorial Google Data Studio"
      video-url="https://www.youtube.com/embed/UBOHg8q4fB8">
      <h1>
        Para acessar o Google Data Studio
        <a
          class="link"
          href="https://lookerstudio.google.com/reporting/create?c.reportId=1a_iA7K3yyKiafKaisVOdZyD8lJv5-ewO&c.mode=edit&r.reportName=API4COM%20-%20Relat%C3%B3rios&ds.connector=community&ds.connectorId=AKfycbwZ7mBKYtabIM7lpSt9y2fj6xz6ro6f90PcLJtKPi1q4Yf_D_Bi2oRjEwFGlfgTDh_X&ds.refreshFields=false"
          target="_blank">
          clique aqui
        </a>.
      </h1>
      <p
        slot="footer"
        class="mb-0">
        Acesse o
        <a
          class="link"
          href="https://ajuda.sacflow.io/api4com/articles/272-como-integrar-sua-conta-api4com-ao-google-looker-studio"
          target="_blank">
          passo a passo
        </a>
        na nossa central de ajuda
      </p>
    </tutorial-video-modal>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="modalBonusCredit"
      ref="modalBonusCredit"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered modal-small"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Seja muito bem-vindo!</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h1>
              Ative Crédito Bônus de R$5,00 Agora!
            </h1>
            <p class="text-first-access">
              Complete a validação do seu CNPJ/CPF para desbloquear um bônus exclusivo de R$5,00 na sua conta.
            </p>
            <p class="text-first-access">
              Valide seus dados
              <a
                class="link"
                href="#"
                @click.prevent="redirectToFinancialData">
                clicando aqui
              </a>
            </p>
            <p class="footer-first-access">
              <a
                class="link"
                href="#"
                @click.prevent="ignoreNotificationBonusCredit">
                Ignorar notificação e acessar o sistema
              </a>
            </p>
          </div>
          <div class="modal-footer" />
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="auth-wrapper">
      <div class="container-fluid h-100">
        <div class="row flex-row h-100 bg-white">
          <div class="col-xl-8 col-lg-6 col-md-5 p-0 d-md-block d-lg-block d-sm-none d-none">
            <div
              class="lavalite-bg"
              style="background-image: url('/static/images/dashOnMac.png')">
              <div class="lavalite-overlay" />
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-7 my-auto p-0">
            <div class="authentication-form mx-auto">
              <div class="logo-centered">
                <img
                  src="/static/images/logo_small.png"
                  alt="Api4Com - API de VOZ integrado com seu CRM"
                  title="Api4Com - API de VOZ integrado com seu CRM">
              </div>
              <slot/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuHeader from '@/components/Container/MenuHeader'
import MenuSidebar from '@/components/Container/MenuSidebar'
import TheBanner from '@/components/Banner.vue'
import BannerFooter from '@/components/BannerFooter.vue'
import ImpersonationBar from '@/components/Support/ImpersonationBar.vue'
import ImpersonatedNotice from '@/components/Support/ImpersonatedNotice.vue'
import ImpersonationConfirmModal from '@/components/Support/ImpersonationConfirmModal.vue'
import TutorialVideoModal from '@/components/Common/TutorialVideoModal.vue'

export default {
  name: 'Container',
  components: {
    MenuHeader,
    MenuSidebar,
    TheBanner,
    BannerFooter,
    ImpersonationBar,
    ImpersonatedNotice,
    ImpersonationConfirmModal,
    TutorialVideoModal
  },
  props: {
    showHeaderMenuAndFooter: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isAdminBonusCreditNotified: false,
      confirmingLogout: false,
      loggingOut: false
    }
  },
  computed: {
    currentYear () {
      return new Date().getFullYear()
    },
    isImpersonating () {
      const impersonation = this.$store.state.auth.impersonation
      return impersonation !== null && impersonation.active === true
    },
    impersonatedClientName () {
      if (this.isImpersonating === false) return ''
      const client = this.$store.state.auth.impersonation.client
      if (client.name === null || client.name === '') return client.email
      return client.name
    }
  },
  updated () {
    this.$nextTick(() => {
      this.showNotificationBonusCredit()
    })
  },
  methods: {
    onRequestLogout () {
      this.confirmingLogout = true
    },
    cancelLogout () {
      if (this.loggingOut === true) return
      this.confirmingLogout = false
    },
    async runLogout () {
      if (this.loggingOut === true) return
      this.loggingOut = true
      if (this.isImpersonating === true) {
        await this.$store.dispatch('auth/stopImpersonation', { followedByLogout: true })
      }
      await this.$store.dispatch('auth/signOut')
      localStorage.removeItem('financialData')
      this.loggingOut = false
      this.confirmingLogout = false
    },
    openTutorialGoogleDataStudio () {
      this.$refs.tutorialGoogleDataStudio.open()
    },
    redirectToFinancialData () {
      $(this.$refs.modalBonusCredit).modal('hide')
      if (this.$router.currentRoute.name === 'financialData') return
      this.$router.push({ name: 'financialData' })
    },
    ignoreNotificationBonusCredit () {
      this.saveLocalStorage('ignoreNotificationBonusCredit', true)
      $(this.$refs.modalBonusCredit).modal('hide')
    },
    saveLocalStorage (key, value) {
      localStorage.setItem(key, value)
    },
    getLocalStorage (key) {
      return localStorage.getItem(key)
    },
    showNotificationBonusCredit () {
      if (this.isAdminBonusCreditNotified) return
      if (Boolean(JSON.parse(this.getLocalStorage('ignoreNotificationBonusCredit'))) === true) return
      if (!this.$store.state.auth.user) return
      if (!this.$store.state.auth.organization) return
      if (this.$store.state.auth.user.role === 'ADMIN') {
        if (
          this.$store.state.auth.softswitchIntegration &&
          this.$store.state.auth.softswitchIntegration.metadata &&
          this.$store.state.auth.softswitchIntegration.metadata.receivedBonusCredit === false
        ) {
          $(this.$refs.modalBonusCredit).modal('show')
        }
      }
      this.isAdminBonusCreditNotified = true
    }
  },
  watch: {
    '$store.state.auth.user': function () {
      this.showNotificationBonusCredit()
    }
  }
}
</script>

<style lang="scss">
.auth-wrapper {
  .lavalite-bg {
    .lavalite-overlay {
      background: linear-gradient(135deg,rgba(3, 55, 122, 0.281) 0%,rgba(44, 142, 255, 0.466) 100%);
    }
  }
}
.text-first-access {
  font-size: 1.1rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Container.vue